@if (node() && formGroup()) {
<div class="group-panel">
    <form class="group-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab) {
                <li class="tab" [hidden]="tab.hidden">
                    <a class="tab-link" (click)="onClick(tab)" [ngClass]="{'active': tabSelected === tab}">{{tab.caption}}</a>
                </li>
                }
            </ul>
        </div>
        <div class="body">
            <div class="row">
                <div class="group-info">
                    Group Name: {{node()!.name}}
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="row">
                <button type="submit" class="button button-big" [disabled]="disabled">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>
}
